<template>
  <div id="logintitle">
    <div class="right_div"> 
      <div
        v-for="(item, inds) in leftlist"
        :key="inds + '0723'"
        class="imgpx"
        @click="handitem(inds)"
      >
        <a-popover
          v-if="inds == 3"
          v-model="visible"
          placement="bottom"
          :destroyTooltipOnHide="true"
          trigger="click"
          :overlayStyle="{ width: 'calc(9rem + 32px)' }"
          :getPopupContainer="
            (triggerNode) => {
              return triggerNode.parentNode;
            }
          "
        >
          <template slot="content">
            <img
              :src="require('@/image/honggu/Wechat - QR CODE.jpg')"
              alt=""
              style="width: 9rem; margin: 0"
              @click="visible = true"
            />
            <center style="text-align: center; font-size: 16px">
              {{ $lang.qmiswx }}
            </center>
            <!-- font-size: 16px; -->
          </template>
          <img
            :src="item.imgurl"
            alt=""
            :class="inds == 1 ? 'met' : ''"
            style="cursor: pointer"
          />
        </a-popover>
        <img
          :src="item.imgurl"
          alt=""
          :class="inds == 1 ? 'met' : ''"
          v-if="inds < 3"
          style="cursor: pointer"
        />
        <span
          :class="inds ? 'myspan' : ''"
          v-if="inds"
          style="cursor: pointer"
          @click="inds == 3 ? (visible = !visible) : ''"
          >{{ islang == "eng" ? item.en_name : item.name }}</span
        >
        <div v-else style="padding: 0; cursor: pointer">
          <span
            style="
              width: 20px;
              display: inline-block;
              text-align: left;
              position: relative;
              margin-right: 0.5rem;
            "
            @click="handleMenuClick({ name: 'EN' })"
            :style="{ borderBottom: islang == 'eng' ? '1px solid #fff' : '' }"
            >EN</span
          >
          <span
            style="
              width: 32px;
              display: inline-block;
              text-align: left;
              position: relative;
            "
            @click="handleMenuClick({ name: 'CN' })"
            :style="{ borderBottom: islang == 'big5' ? '1px solid #fff' : '' }"
            >中文</span
          >
        </div>
        <!-- <a-dropdown v-else >
                    <a-menu slot="overlay" style='position: relative;left: -1.2rem;'>
                      <a-menu-item :key="ind" v-for='(item,ind) in langage' style='width: 4.8rem;' @click="handleMenuClick(item)">
                          <a-row>
                            <a-col :span='4'>
                              <img :src="item.url" alt="" style="width: 1rem;">
                            </a-col>
                            <a-col :span='19'><div style="font-size: 16px;display: flex;justify-content: space-between;
                            align-items: center;">{{item.name}}
                            <a-icon type="right" style='font-size: .7rem;'/></div></a-col>
                          </a-row>
                      </a-menu-item>
                    </a-menu>
                    <span style="width: 2rem;display: inline-block;text-align: left;position: relative;">{{iskey.name}}                     <a-icon type="right" style='font-size: .7rem;position: absolute;right: -.7rem;top: 0.25rem;'/></span>
            </a-dropdown> -->
        <span
          style="position: relative; left: 1rem; color: #b5b5b5; "
          >{{ leftlist.length > inds + 1 ? "|" : "" }}</span
        >
      </div>
    </div>
    <div class="tit_heard">
      <div>
        <img
          :src="require('@/image/home/logo.png')"
          alt=""
          @click="handclick"
          style="width: 12rem;cursor: pointer;"
        />
      </div>
      <div class="warp_right">
        <div
          v-for="(val, i) in shouyelist"
          :key="i + '6699'"
          v-html="islang == 'eng' ? val.en_name : val.name"
          :class="islink === val.index ? 'hovelink' : ''"
          @click="handlink(i,val)"
          style="cursor: pointer"
        ></div>
        <img
          :src="
            islink === 'img'
              ? require('@/image/home/search_g.png')
              : require('@/image/home/search.png')
          "
          alt=""
          @click="showstran()"
        />
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="show" class="desktop-search-collapsible">
        <!-- <form class="header-search show"> -->
        <!--  method="GET" action="/search" -->
        <input
          type="text"
          v-model="qvalue"
          title="Type search term here"
          :placeholder="$lang.inSearch"
          class="seachinput"
          @keyup.enter="calAge()"
        />
        <button @click="handval" type="submit" class="submit fas fa-search">
          <a-icon type="search" />
        </button>
        <!-- </form> -->
      </div>
    </transition>
    <handitem v-if="ishand" @child="handback"></handitem>
  </div>
</template>

<script>
import handitem from "./handitem.vue";
export default {
  props: ["gonum", "handnum"],
  components: { handitem },
  data() {
    return {
      qvalue: "",
      visible: false,
      shShowBol: false,
      iskey: {
        // name:'EN >',
        // url:require('@/image/new/EN.png')
      },
      langage: [
        {
          name: "EN",
          url: require("@/image/new/EN.png"),
        },
        {
          name: "中文",
          url: require("@/image/new/CN.png"),
        },
      ],
      show: false, //动画
      ishand: false,
      islang: window.localStorage.guanwanglang,
      islink: 0,
      leftlist: [
        {
          imgurl: require("@/image/home/langage.png"),
          name: "中文 >",
          en_name: "EN >",
        },
        // {
        //   imgurl: require("@/image/home/jiao.png"),
        //   name: "網上開戶",
        //   en_name: "Online Account Opening",
        // },
        {
          imgurl: require("@/image/home/yuyue.png"),
          name: "預約開戶",
          en_name: "Make Appointment",
          // }, {
          //   imgurl: require('@/image/home/joinwe.png'),
          //   name: '加入我們',
          //   en_name:'Join Us'
        },
        {
          imgurl: require("@/image/home/jiao.png"),
          name: "在線開戶",
          en_name: "Account Opening",
        },
        // {
        //   imgurl: require("@/image/home/out.png"),
        //   name: "微信公眾平台",
        //   en_name: "Wechat Account",
        // },
      ],
      shouyelist: [
        { name: "首頁",index:0, en_name: "Home", url: "/" },
        {
          name: "產品及服務",
          index:1,
          en_name: "Products & Services",
          url: "/products&services",
        },
        {
          name: "網上交易",
          index:2,
          en_name: "Online Trading",
          url: "https://iglobal.qmis.com.hk/mts.web/Web2/login/qmis/index.html#",
        },
        {
          name: "客戶服務",
          index:3,
          en_name: "Customer Services",
          url: "/apply_in_person_individual",
        },
        { name: "關於我們",index:4, en_name: "About Us", url: "/about_us" },
        { name: "聯絡我們",index:5, en_name: "Contact Us", url: "/contact_us" },
      ],
    };
  },
  mounted() {
    if (this.handnum) {
      this.islink = this.handnum;
    }
    if (this.islang == "eng") {
      this.iskey = this.langage[0];
    } else {
      this.islang = "big5"
      this.iskey = this.langage[1];
    }
    this.loginFlag()
  },
  methods: {
    loginFlag(){
      this.$ajax({
        method:'post',
        url:this.$api.getSwitchStatus
      }).then(res=>{
        if(res.data.code === 1000){
          if (res.data.data.switchStatus) {
            this.shouyelist = [
              { flaglogin:false,index:0,name: "首頁", en_name: "Home", url: "/" },
              {
                flaglogin:false,
                name: "產品及服務",
                index:1,
                en_name: "Products & Services",
                url: "/products&services",
              },
              {
                flaglogin:true,
                name: "網上交易",
                index:2,
                en_name: "Online Trading",
                url: "https://iglobal.qmis.com.hk/mts.web/Web2/login/qmis/index.html#",
              },
              {
                flaglogin:false,
                name: "客戶服務",
                index:3,
                en_name: "Customer Services",
                url: "/apply_in_person_individual",
              },
              { flaglogin:false,index:4,name: "關於我們", en_name: "About Us", url: "/about_us" },
              { flaglogin:false,index:5,name: "聯絡我們", en_name: "Contact Us", url: "/contact_us" },
            ]
          }else{
            this.shouyelist = [
              { name: "首頁", index:0,en_name: "Home", url: "/" },
              {
                name: "產品及服務",
                index:1,
                en_name: "Products & Services",
                url: "/products&services",
              },
            
              {
                name: "客戶服務",
                index:3,
                en_name: "Customer Services",
                url: "/apply_in_person_individual",
              },
              { name: "關於我們",index:4, en_name: "About Us", url: "/about_us" },
              { name: "聯絡我們",index:5, en_name: "Contact Us", url: "/contact_us" },
            ]
          }
        }else{
          this.$message.warning(res.data.message)
        }
      })
    },
    calAge(e) {
      var evt = window.event || e;
      if (evt.keyCode == 13) {
        console.log("----------");
        this.handval();
      }
    },
    handval() {
      if (this.qvalue) {
        this.$router.push({
          path: "/sreachpage",
          query: {
            value: this.qvalue,
          },
        });
      }
    },
    showstran() {
      this.show = !this.show;
    },
    handleMenuClick(val) {
      // this.iskey = this.langage[val.key]
      // let num =  this.iskey.name == 'EN'? 1:0;
      this.iskey = val;
      // if(i== 0){
      if (val.name == "EN") {
        window.localStorage.guanwanglang = "";
        window.localStorage.guanwanglang = "eng";
      } else {
        window.localStorage.guanwanglang = "";
        window.localStorage.guanwanglang = "big5";
      }
      setTimeout(() => {
        location.href = location.href.split("?lang=")[0];
        // location.reload();
      }, 200);
      // }
    },
    handback() {
      this.ishand = false;
    },
    postdata(){
      this.$ajax({
        method:'post',
        url:this.$api.yuyuekaihu
      }).then(res=>{
        if(res.data.qmiscode === 1000){
        }else{
          this.$message.warning(res.data.qmismsg)
        }
      })
    },
    wangshangjiaoyi(){
      this.$ajax({
        method:'post',
        url:this.$api.wangshangjiaoyi
      }).then(res=>{
        if(res.data.qmiscode === 1000){
        }else{
          this.$message.warning(res.data.qmismsg)
        }
      })
    },
    zaixiankaihu(){
      this.$ajax({
        method:'post',
        url:this.$api.zaixiankaihu
      }).then(res=>{
        if(res.data.qmiscode === 1000){
        }else{
          this.$message.warning(res.data.qmismsg)
        }
      })
    },

    handitem(i) {
      let arr = [
        "https://hk.qmisit.com/accopen/?lang=",
        // "https://hk.iqmis.com/accopen/main/Officialwebsite?lang=",
        "https://hk.iqmis.com/accopen/main/Officialwebsite?lang=",
        "/contact_us",
        "https://hk.qmisit.com/accopen/?lang=",
      ];
      if (i == 1) {
        this.postdata()
        this.$router.push('/account_opening_appointment')
        // window.open(arr[i] + this.islang);
      }
      if(i == 2){
        this.zaixiankaihu()
        // this.$router.push('/account_opening_online')
        window.open("https://hk.qmisit.com/accopen/?lang="+ this.islang);

      }
      // if(i==2){
      //   this.$router.push('/join_us')
      // }
      if (i == 3) {
        // this.ishand = true
        this.shShowBol = true;
      }
    },
    handlink(i,val) {
      this.islink = val.index;
      // if(i==1){
      //   this.$emit('child',1)
      //   this.$router.push({
      //     path:this.shouyelist[i]['url'],
      //     // query: {isdiv:'1'}
      //   })
      // }else
      if (val.flaglogin == true) {
        this.wangshangjiaoyi()
        // return
        window.open(
          this.shouyelist[i]["url"] + window.localStorage.guanwanglang
        );
      } else if (this.shouyelist[i]["url"]) {
        this.$router.push(this.shouyelist[i]["url"]);
      }
    },
    handclick() {
      // let str = location.protocol+location.host+'/qmisgroup'
      // window.location.href = 'http://120.79.92.205/qmisgroup'
      // this.$router.go(this.gonum)

      if (location.hostname == "qmisgroup.com") {
        window.location.href = "http://www.qmisgroup.com/";
      } else {
        //  window.location.href = 'http://120.79.92.205/qmisgroup'
        this.$router.push("/");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 1100px) {
  .myspan {
    display: none;
  }
  #logintitle .imgpx img {
    width: 2rem;
    margin: 0.5rem;
  }
  .warp_right {
    display: none;
  }
}
</style>
<style scoped lang="less">
#logintitle .seachinput {
  width: calc(95%) !important;
  outline: none;
  display: inline-block;
  border: 0;
  padding: 6px 0;
  border-bottom: 1px solid #d5d3d3;
}

#logintitle .seachinput::-webkit-input-placeholder {
  font-size: 18px;
}

#logintitle .ant-popover-inner-content {
  padding: 0.2rem !important;
}

#logintitle .tit_heard {
  z-index: 100;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 0 5px #888888;
  background: #f5f5f5;
  // padding: .2rem .2rem .2rem 0;
  padding: 0.2rem 1rem 0.2rem 0;
}

#logintitle .right_div {
  margin: 0rem;
  background-color: #09666e;
  color: #fff;
  padding: 0 0.2rem;
  text-align: right;
  div {
    padding: 0 1rem;
    display: inline-block;
    text-align: right;
    // font-size: 16px;
    font-size: 15px;
  }
}

#logintitle .login-title {
  font-size: 6rem;
  font-weight: 500;
  letter-spacing: 15px;
  color: #fff;
  padding-top: 5rem;
  text-align: center;
}

#logintitle .imgpx img {
  width: 1rem;
  margin: 0.5rem 0.5rem 0.4rem 0.5rem;
  position: relative;
  top: -0.1rem;
  // position: relative;
  // line-height: .6rem;
  // vertical-align: bottom;
  // bottom: -.1rem;
}

.warp_right {
  position: relative;
  top: 0.9rem;
}

.warp_right div {
  display: inline-block;
  // font-size: 16px;
  font-size: 16px;
  color: #333;
  // width: 4rem;
  padding: 0;
  // margin: 1.2rem 1rem;
  margin: 0 1rem;
}

.hovelink {
  border-bottom: 2px solid #09666e;
  color: #09666e !important;
  font-weight: 600;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  transform: translateY(-1rem);
  opacity: 0;
}

.desktop-search-collapsible {
  padding: 8px 0;
  text-align: center;
}

.fa-search {
  margin: 0 8px;
  font-size: 18px;
  color: #5f5d5d;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login_pc.vue